import cookie from 'react-cookie';
import jwtDecode from 'jwt-decode';
import Util from './Util';
import User from './model/User';
import _ from 'lodash';

class Storage {
  /**
   * cookies
   */

  static cookie = cookie;

  static getToken() {
    let token = cookie.load('token');
    if (token) {
      let decoded = jwtDecode(token);
      let expDate = new Date(decoded.exp * 1000);
      let curDate = new Date();
      if (curDate > expDate) {
        return '';
      }
    }
    return token;
  }

  static hasValidToken() {
    let token = Storage.getToken();
    return !_.isEmpty(token);
  }

  static getDecodedToken() {
    let token = cookie.load('token');
    if (token) {
      let decoded = jwtDecode(token);
      return decoded;
    }
    return null;
  }

  static getProfile() {
    let obj = Storage.getItem('user');
    if (obj) {
      return new User(obj);
    }
    return null;
  }

  static isProfileCommissionRole() {
    let user = Storage.getProfile();
    if (user) {
      return user.isCommissionRole();
    }
    return false;
  }

  static getProfileEmail() {
    let user = Storage.getProfile();
    if (user) {
      return user.email;
    }
    return null;
  }

  static setProfile(user) {
    // store in localStorage to reduce cookie size and not needed to store in cookie
    // cookie.save('user', user, { path: '/' });
    Storage.setItem('user', user);
  }

  // todo: Send "Set-Cookie" header in login response instead of client-side setting cookie which allow to set http only cookie and https cookie.
  static setToken(token, user) {
    let decoded = jwtDecode(token);
    // console.log('setJwtToken', decoded);
    __DEBUG__ &&
      console.log(
        'token expired at:',
        Util.localDateTimeString(new Date(decoded.exp * 1000))
      );

    // let expDate = new Date(decoded.exp * 1000);
    cookie.save('token', token, { path: '/' });
    // cookie.save('user', user, { path: '/' });
    Storage.setItem('user', user);
  }

  static clearToken() {
    cookie.remove('token', { path: '/' });
    cookie.remove('user', { path: '/' });
    Storage.removeItem('user');
  }

  static clearTokenAndSessionData() {
    Storage.clearToken();
    Storage.clearSessionItems();
  }

  static clearSheldonFileCache() {
    let keys = Object.keys(window.sessionStorage);
    for (let k of keys) {
      if (/^file/.test(k)) {
        window.sessionStorage.setItem(k, '');
      }
    }
  }

  /**
   * localStorage
   */

  static getItem(key) {
    let value = window.localStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  static setItem(key, value) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    window.localStorage.setItem(key, value);
  }

  static removeItem(key) {
    window.localStorage.removeItem(key);
  }

  static getText(key) {
    return window.localStorage.getItem(key);
  }

  /**
   * sessionStorage
   */

  static getSessionItem(key) {
    let value = window.sessionStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  static setSessionItem(key, value) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    window.sessionStorage.setItem(key, value);
  }

  static removeSessionItem(key) {
    window.sessionStorage.removeItem(key);
  }

  static getSessionText(key) {
    return window.sessionStorage.getItem(key);
  }

  static clearSessionItems() {
    window.sessionStorage.clear();
  }

  static setTabPathname(tabName, pathname) {
    Storage.setSessionItem('tab.' + tabName, pathname);
  }
  static getTabPathname(tabName) {
    return Storage.getSessionItem('tab.' + tabName);
  }
}

export default Storage;



// WEBPACK FOOTER //
// ./src/Storage.js